import { render, staticRenderFns } from "./BroCoinExtraFields.vue?vue&type=template&id=363427c9&"
import script from "./BroCoinExtraFields.vue?vue&type=script&lang=js&"
export * from "./BroCoinExtraFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports